<template>
  <transition :name="transitionName">
    <keep-alive>
      <navigation>
        <router-view ref="base" class="child-view"></router-view>
      </navigation>
    </keep-alive>
  </transition>
</template>

<script type="text/ecmascript-6">
  export default {
    data () {
      return {
        transitionName: '',
        isMobile: false
      }
    },
    created () {
      this.$navigation.on('forward', (to, from) => {
        if (!from || !from.name || from.name.indexOf('start') !== -1) {
          this.transitionName = ''
        } else if (to && to.route && to.route.query && to.route.query.hasOwnProperty('animation')) {
          if (!to.route.query.animation) {
            this.transitionName = ''
          } else {
            this.transitionName = 'slide-left'
          }
        } else {
          this.transitionName = 'slide-left'
        }
      })
      this.$navigation.on('back', (to, from) => {
        this.transitionName = 'slide-right'
      })
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "common/stylus/index.styl"
  .child-view
    /*position: absolute*/
    width: 100%
    transition: all 0.4s

  .slide-left-enter, .slide-right-leave-active
    transform: translate3d(100%, 0, 0)

  .slide-left-leave-active, .slide-right-enter
    transform: translate3d(-100%, 0, 0)

  .slide-right-leave-active, slide-left-leave-active
    transition: all 0.4s ease
</style>



// WEBPACK FOOTER //
// src/App.vue